module.exports = __webpack_public_path__ + "img/WOOCOMMERCE_SMALL.07aafee5.svg";